import { observer } from "mobx-react-lite";
import React from "react";
import { SideDrawer } from "@dmc/ui";
import ApiData from "../../api/ApiData";
import { ButtonFunctional } from "../UI/ButtonFunctional";
import AlertData from "../../api/AlertData";

const PERIOD_INFINITY = 9000;

export const RenewalLicensing = observer(({ setVisibleRenewalBlock }) => {
  const renewalLicensing = async () => {
    ApiData.renewalLic(PERIOD_INFINITY);
    setVisibleRenewalBlock(false);
    await AlertData.calcError();
  };

  const close = () => setVisibleRenewalBlock(false);

  return (
    <SideDrawer
      open
      onClose={close}
      title="Продление лицензии"
      usePortal={false}
      footer={
        <>
          <ButtonFunctional onClick={renewalLicensing}>
            Продлить лицензию
          </ButtonFunctional>
          <ButtonFunctional onClick={close}>Отмена</ButtonFunctional>
        </>
      }
    >
      <div className="site-modal-body">
        <div className="generation_lic_period_block">
          <div className="tabs_lgt_grey_border generation_lic_min_block_left">
            <span>Срок продления: </span>
            <div className="generation_lic_btn_period">
              <span className="btn_active_period">Бессрочно</span>
            </div>
          </div>
        </div>
      </div>
    </SideDrawer>
  );
});
